import './QuoteBlock.css';

function QuoteBlock(props) {
    return (
        <h2 className="quote section page-block page-block--full">{props.quote}</h2>
    );
}

export default QuoteBlock;